import React from "react";
import { TrainingCenterBundleDueDateId } from "../../../messages/ObjectIds";
import { STRINGS } from "../../../strings";
import { TrainingCenterCaregiverBundle } from "../../../system/AppState/AppStateTrainingCenter";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import { AppCard } from "../../Generic/AppCard";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import { convertBundleItemsToCourses } from "../../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleCardBanner from "./TrainingCenterBundleCardBanner";
import TrainingCenterBundleCardCoursesList from "./TrainingCenterBundleCardCoursesList";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  languagePreference: TrainingCenterLanguagePreference;
  onClick: (bundleDueDateId: TrainingCenterBundleDueDateId) => void;
}

const TrainingCenterBundleCard = (props: Props) => {
  const { courses } = convertBundleItemsToCourses(props.bundle.bundleItems);

  const onClick = () => {
    props.onClick(props.bundle.bundleDueDateId);
  };

  return (
    <AppCard className="TrainingCenterBundleCard" onClick={onClick}>
      <TrainingCenterBundleCardBanner
        bundle={props.bundle}
        languagePreference={props.languagePreference}
      />

      <TrainingCenterBundleCardCoursesList
        bundleDueDateId={props.bundle.bundleDueDateId}
        courses={courses}
        languagePreference={props.languagePreference}
      />

      <div className="bundle-button">
        <AppButton onClick={onClick} variant="soft" size="small">
          {translate(STRINGS.START_WATCHING)}
        </AppButton>
      </div>
    </AppCard>
  );
};

export default TrainingCenterBundleCard;
